<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
    message: String,
    type: {
        type: String,
        default: "info", // success, error, warning, info
    },
    duration: {
        type: Number,
        default: 3000, // 3 seconds
    },
    onClose: Function,
});

const visible = ref(true);

onMounted(() => {
    setTimeout(() => {
        visible.value = false;
        props.onClose?.();
    }, props.duration);
});

const typeClasses = {
    success: "bg-green-500 text-white",
    error: "bg-red-500 text-white",
    warning: "bg-yellow-500 text-black",
    info: "bg-blue-500 text-white",
};
</script>

<template>
    <transition name="fade">
        <div
            v-if="visible"
            :class="[
                'fixed bottom-5 right-5 px-4 py-2 rounded-lg shadow-lg lg:max-w-sm',
                typeClasses[type],
            ]"
        >
            {{ message }}
        </div>
    </transition>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
